import { toQueryStr, toQueryStrWithPagination } from "@/core/helpers/stringHelper";
import JwtService from "../JwtService";

const ServiceConstants = {
    Common: {
        Page: 'Page',
        PageSize: 'PageSize',
        ListPath: function (name: string, page: number, pageSize: number) {
            return `${name}/${this.Page}/${page}/${this.PageSize}/${pageSize}`;
        },
        FilteredListPath: function (name: string, page: number, pageSize: number, filters: any) {
            let path = this.ListPath(name, page, pageSize)
            const filtersQuery = toQueryStr(filters)
            if (filtersQuery && filtersQuery !== "?") {
                path = `${path}${filtersQuery}`;
            }
            return path
        },
        FilteredListPathWithExport: function (name: string, filters: any) {
            let path = this.ListPath(name, 1, 2147483647)
            const filtersQuery = toQueryStr(filters)
            if (filtersQuery && filtersQuery !== "?") {
                path = `${path}${filtersQuery}&export=true`;
            }
            else {
                path = `${path}?export=true`;
            }
            return path
        },
        FilteredListPathQs: function (name: string, page: number, pageSize: number, filters: any) {
            let path = name
            const filtersQuery = toQueryStrWithPagination(page, pageSize, filters)
            if (filtersQuery && filtersQuery !== "?") {
                path = `${path}${filtersQuery}`;
            }
            return path
        },
        FilteredListPathQsWithExport: function (name: string, filters: any) {
            let path = name
            const filtersQuery = toQueryStrWithPagination(1, 2147483647, filters)
            if (filtersQuery && filtersQuery !== "?") {
                path = `${path}${filtersQuery}&export=true`;
            }
            else {
                path = `${path}?export=true`;
            }

            return path
        },
        DetailPath: function (name: string, id: string) {
            return `${name}/${id}`;
        }
    },
    Identity: {
        Membership: {
            Claim: {
                Name: "Claim",
                ClaimListPath: function (page: number, pageSize: number) {
                    return ServiceConstants.Common.ListPath(this.Name, page, pageSize);
                },
                ClaimDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Role: {
                Name: "Role",
                RoleListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                RoleDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            User: {
                Name: "User",
                UserListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                UserDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Auth: {
                LoginPath: "auth/login",
                VerifyAuthPath: "auth/verify",
                LogoutPath: function (id: string) { return `auth/${id}/logout`; },
                VerifyPath: "auth/validate",
                ChangePasswordPath: 'auth/changePassword',
                ForgotPasswordPath: 'auth/forgotPassword',
                ResetPasswordPath: 'auth/resetPassword'
            }
        },
    },
    Agent: {
        Automation: {
            Job: {
                Name: 'Job',
                JobListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                JobExportPath: function (filters: any) {
                    return ServiceConstants.Common.FilteredListPathWithExport(this.Name, filters);
                },
                JobDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Trigger: {
                Name: 'Trigger',
                TriggerListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                TriggerDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
                Mail: {
                    Name: 'Mail',
                    TestConnectionPath: function(providerName){
                        return `${ServiceConstants.Agent.Automation.Trigger.Name}/${this.Name}/TestConnection/${providerName}`;
                    }
                }
            },
            Process: {
                Name: 'Process',
                ProcessListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                ProcessDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            }
        },
        Packaging: {
            Package: {
                Name: 'Package',
                PackageListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                PackageDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
            },
            PackageVersion: {
                Name: 'PackageVersion',
                PackageVersionListPath: function (packageId: string) {
                    return `${this.Name}/byPackageId/${packageId}`
                },
            }
        },
        Queueing: {
            Queue: {
                Name: 'Queue',
                QueueListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                QueueDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
            },
            Transaction: {
                Name: 'Transaction',
                TransactionListPath: function (queueId: string, page: number, pageSize: number) {
                    return `${this.Name}/byQueueId/${queueId}/page/${page}/pageSize/${pageSize}`
                },
                TransactionDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            }
        },
        Variance: {
            Asset: {
                Name: 'Asset',
                AssetListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                AssetDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Credential: {
                Name: 'Credential',
                CredentialListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                CredentialDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            }
        }
    },
    Orchestrator: {
        Configuration: {
            Machine: {
                Name: 'Machine',
                MachineListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                MachineDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Robot: {
                Name: 'Robot',
                RobotListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                RobotDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
                RobotUpdateDetailsPath: function (id: string) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/details`
                },
                RobotUpdateCredentialsPath: function (id: string) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/credentials`
                },
                RobotUpdateLicensesPath: function (id: string) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/licenses`
                }
            },
            Environment: {
                Name: 'Environment',
                EnvironmentListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                EnvironmentDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            }
        },
        Communication: {
            SupportRequest: {
                Name: "SupportRequest",
                SupportRequestListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                SupportRequestDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
                SupportRequestStartPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id) + '/start';
                },
                SupportRequestResolvePath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id) + '/resolve';
                },
                SupportRequestRejectPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id) + '/reject';
                },
                SupportRequestCancelPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id) + '/cancel';
                },
                SupportRequestReplyPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id) + '/reply';
                },
            },
            SupportRequestCategory: {
                Name: "SupportRequestCategory",
                SupportRequestCategoryListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                SupportRequestCategoryDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
            },
        },
        Settings: {
            Parameter: {
                Name: 'Parameter',
                ParameterListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                ParameterDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Language: {
                Name: 'Language',
                LanguageListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                LanguageDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            MailAccount: {
                Name: 'MailAccount',
                MailAccountListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                MailAccountDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            MailTemplate: {
                Name: 'MailTemplate',
                MailTemplateListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                MailTemplateDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            NonWorkingDay: {
                Name: 'NonWorkingDay',
                NonWorkingDayListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                NonWorkingDayDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            ApplicationClient: {
                Name: 'ApplicationClient',
                ApplicationClientListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                ApplicationClientDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Translation: {
                Name: "Translation",
                TranslationListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPath(this.Name, page, pageSize, filters);
                },
                AllTranslationsListPath: function () {
                    return `${this.Name}/all`
                },
                GetWordPath: function (key: string) {
                    return `translation/${key}/value`
                },
                TranslationDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            }
        }
    },
    Logging: {
        Name: 'Logs',
        Common: {
            All: function (page: number, pageSize: number) {
                return `logs/page/${page}/pageSize/${pageSize}`
            },
            Single: function (id) {
                return `logs/${id}`
            }
        },
        System: {
            AuditAll: function (page: number, pageSize: number) {
                return `logs/audit/page/${page}/pageSize/${pageSize}`
            },
            AuditExport: function () {
                return `logs/audit/page/1/pageSize/2147483647?export=true`
            },
            ExceptionAll: function (page: number, pageSize: number) {
                return `logs/exceptions/page/${page}/pageSize/${pageSize}`
            },
            ExceptionExport: function () {
                return `logs/exceptions/page/1/pageSize/2147483647?export=true`
            },
            FatalExceptionAll: function (page: number, pageSize: number) {
                return `logs/fatalExceptions/page/${page}/pageSize/${pageSize}`
            },
            FatalExport: function () {
                return `logs/fatalExceptions/page/1/pageSize/2147483647?export=true`
            },
            ImportAll: function (page: number, pageSize: number) {
                return `logs/import/page/${page}/pageSize/${pageSize}`
            },
            ImportExport: function () {
                return `logs/import/page/1/pageSize/2147483647?export=true`
            },
        },
        Robot: {
            All: function (page: number, pageSize: number) {
                return `logs/robot/page/${page}/pageSize/${pageSize}`
            },
            Export: function () {
                return `logs/robot/page/1/pageSize/2147483647?export=true`
            }
        }
    },
    CustomerService: {
        CustomerManagement: {
            Company: {
                Name: "Company",
                CompanyListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                CompanyDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
                SendDocumentsPath: function (id: string) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/sendDocuments`;
                }
            },
            Machine: {
                Name: 'Machine',
                MachineListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                MachineDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            MemberInfo: {
                Name: 'MemberInfo',
                SendResetPasswordMailPath: function (id: string) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/sendResetPasswordMail`;
                }
            }
        },
        Licensing: {
            LicenseDefinition: {
                Name: "LicenseDefinition",
                LicenseDefinitionListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                LicenseDefinitionDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            LicenseType: {
                Name: "LicenseType",
                LicenseTypeListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                LicenseTypeDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            CompanyLicense: {
                Name: "CompanyLicense",
                CompanyLicenseListPath: function (companyId: string, page: number, pageSize: number) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/byCompany/${companyId}`, page, pageSize, null);
                },
                CompanyRobotLicensesPath: function (companyId: string) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/byCompany/${companyId}`, 1, 1000, { onlyRobotLicenses: true });
                },
                CompanyRobotLicensesByRobotIdPath: function (robotId: string) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/byRobot/${robotId}`, 1, 1000, null);
                },
                CompanyStudioLicensesPath: function (companyId: string) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/byCompany/${companyId}`, 1, 1000, { onlyStudioLicenses: true });
                },
                CompanyMindPilotLicensesPath: function (id: string) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/byCompany/${id}`, 1, 1000, { onlyMindPilotLicenses: true });
                },
                CompanyStudioAndMindPilotLicensesPath: function (id: string) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/byCompany/${id}`, 1, 1000, { studioAndMindpilotLicenses: true });
                },
                CompanyRobotAndMindPilotLicensesPath: function (id: string) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/byCompany/${id}`, 1, 1000, { robotAndMindpilotLicenses: true });
                },
                GetAllCompanyLicensesPath: function (companyId: string) {
                    return `${this.Name}/byCompany/${companyId}`
                },
                CompanyLicenseDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                },
                ConsumptionsPath: function (licenseId: string, page: number, pageSize: number) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/${licenseId}/consumptions`, page, pageSize, null);
                },
                ConsumptionDetailPath: function (consumptionId: string) {
                    return ServiceConstants.Common.DetailPath(`${this.Name}/consumption`, consumptionId);
                },
                ConsumptionJobsPath: function (consumptionId: string, page: number, pageSize: number) {
                    return ServiceConstants.Common.FilteredListPathQs(`${this.Name}/consumption/${consumptionId}/jobs`, page, pageSize, null);
                },
                LicenseQuantityChangePath: function (id: string, quantity: number) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/changeQuantity/${quantity}`;
                },
                LicenseOverflowOperationChangePath: function (id: string, newOperation: number) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/changeOverflowOperation/${newOperation}`;
                },
                LicenseUnitPriceChangePath: function (id: string, unitPrice: number) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/changeUnitPrice/${unitPrice}`;
                },
                LicenseConsumptionsPath: function (id: string) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/consumptions`;
                },
                LicenseFixUnitPricePath: function (id: string, fix: boolean) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/fixUnitPrice/${fix}`;
                },
                EndLicensePath: function (id: string) {
                    return `${ServiceConstants.Common.DetailPath(this.Name, id)}/endLicense`;
                }
            }
        },
        Validation: {
            Name: 'Validation',
            ReCaptcha: 'Validation/recaptcha'
        },
        Releases: {
            Name: "releases",
            StudioPath: function (langCode: string) {
                return `Releases/studio/${langCode}`
            },
            AgentPath: function (langCode: string) {
                return `Releases/agent/${langCode}`
            },
            Download: {
                Studio: function (fileName: string) {
                    return `Releases/studio/download/${fileName}`
                },
                Agent: function (fileName: string) {
                    return `Releases/agent/download/${fileName}`
                },
                Installer: function(){
                    return `Releases/setup/latest`
                }
            }
        },
        Settings: {
            Name: 'Settings',
            Language: {
                Name: 'Language',
                LanguageListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                LanguageDetailPath: function (id: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, id);
                }
            },
            Translation: {
                Name: "Translation",
                TranslationListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                TranslationDetailPath: function (key: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, key);
                }
            },
            Program: {
                Name: "Program",
                ProgramListPath: function (page: number, pageSize: number, filters: any) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, filters);
                },
                ProgramDetailPath: function (key: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, key);
                }
            },
            TokenProvider: {
                Name: "TokenProvider",
                TokenProviderListPath: function (page: number, pageSize: number) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, null);
                },
                TokenProviderDetailPath: function (key: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, key);
                }
            },
            TokenRegistry: {
                Name: "TokenSubscription",
                TokenRegistryListPath: function (page: number, pageSize: number) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, null);
                },
                TokenRegistryDetailPath: function (key: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, key);
                },
                TokenRegistryByCompanyIdAndBaseTypePath: function (companyId: string, baseType: string) {
                    return `${this.Name}/company/${companyId}/baseType/${baseType}`
                },
                TokenRegistryByCompanyIdPath: function (companyId: string) {
                    return `${this.Name}/company/${companyId}`
                }
            },
            Document: {
                Name: "Document",
                DocumentListPath: function (page: number, pageSize: number) {
                    return ServiceConstants.Common.FilteredListPathQs(this.Name, page, pageSize, null);
                },
                DocumentDetailPath: function (key: string) {
                    return ServiceConstants.Common.DetailPath(this.Name, key);
                }
            },
        },
    }
}

export default ServiceConstants;